var map = {
	"./de-DE/google-play-badge.png": "d3f8",
	"./en-GB/google-play-badge.png": "9d10",
	"./en-US/google-play-badge.png": "542f",
	"./es-ES/google-play-badge.png": "7cd3",
	"./es-MX/google-play-badge.png": "5e42",
	"./fr-CA/google-play-badge.png": "d3c7",
	"./fr-FR/google-play-badge.png": "d72d",
	"./it-IT/google-play-badge.png": "9130",
	"./ja-JP/google-play-badge.png": "928f",
	"./pt-BR/google-play-badge.png": "acdc",
	"./zh-TW/google-play-badge.png": "ff11"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e8c7";